import Vue from 'vue';
import moment from 'moment';
import ENUM from '@/utils/enum';
import Utils from '@/utils/utils';
import App from '@/utils/app';
import Setting from '@/utils/setting';
import Config from '@/config';
import ActivityApi from '@/api/activity';
import './lazy_lib/components_use'; // 按需加载 UI/全局 组件
import './report'; // 阿里云日志上报
import BUS from '@/utils/bus';
BUS(Vue);
Vue.prototype.$Moment = moment;
Vue.prototype.$ENUM = ENUM;
Vue.prototype.$Utils = Utils;
Vue.prototype.$Setting = Setting;
Vue.prototype.$Config = Config;
Vue.prototype.$App = App;
Vue.prototype.$GetActivity = ActivityApi.anniversaryActivityTime;

// //配置微信公众号授权
// Vue.use(wxAuth, {
//   appid: Config.appId,
//   scope: 'snsapi_userinfo',
// })